<div class="product-promotion" [ngClass]="{
'product-promotion__fixed-height': hasFixedHeight,
'product-promotion__multi-row-labels': multiRowLabel,
'rounded-labels': roundedLabels,
'new-design': isNewDesign
}" fxLayoutGap="8px">

  <div *ngIf="!isNewDesign && !!msrpDiscount" class="product-promotion__percentage product-promotion__percentage__msrp"
       test-target="product-promotion__percentage">
    - {{msrpDiscount}}%
  </div>

  <div *ngIf="!msrpDiscount && promotion && fromProductCard && !isBlackDealsEnabled && !hasVolumePrice"
    class="product-promotion__percentage product-promotion__percentage__deal">
    {{ 'CORE.ALL_PAGES.PRODUCT_PROMO.LABEL' | translate }}
  </div>

  <div *ngIf="hasVolumePrice && volumePriceQuantity && volumePricePercentage && !isBlackDealsEnabled"
    class="product-promotion__percentage product-promotion__percentage__deal product-promotion__percentage__volume-price">
    {{'CORE.ALL_PAGES.PRODUCT_PROMO.LABEL.VOLUME_PRICING' | translate: { volumePriceQuantity: volumePriceQuantity,
    volumePricePercentage: volumePricePercentage } }}
  </div>

  <div *ngIf="isBlackDealsEnabled" class="product-promotion__black-deals">
    {{ 'CATALOG.DETAILS_PAGE.BLACK_DEALS.LABEL' | translate }}
  </div>

  <div *ngIf="serie" class="product-promotion__percentage product-promotion__percentage__deal product-promotion__series">
    {{ 'CATALOG.CATALOG_PAGE.PRODUCT-CARD.SERIES' | translate }}
  </div>
</div>
